import React from 'react';
import { Eye, FileText } from 'lucide-react';

interface FileListProps {
  files: Array<{ id: string; name: string }>;
  selectedFiles: string[];
  onSelect: (fileName: string, selected: boolean) => void;
  onSelectAll: (selected: boolean) => void;
  onPreview: (fileName: string) => void;
  canPreview: (fileName: string) => boolean;
}

export default function FileList({ 
  files, 
  selectedFiles, 
  onSelect, 
  onSelectAll,
  onPreview,
  canPreview
}: FileListProps) {
  const allSelected = files.length > 0 && files.every(file => selectedFiles.includes(file.name));

  return (
    <div className="space-y-4">
      {files.length > 0 && (
        <div className="flex items-center gap-2 mb-4">
          <input
            type="checkbox"
            checked={allSelected}
            onChange={(e) => onSelectAll(e.target.checked)}
            className="rounded border-gray-300 text-[#024994] focus:ring-[#024994]"
          />
          <span className="text-sm text-gray-600">
            Selectează toate
          </span>
        </div>
      )}
      
      <div className="space-y-2">
        {files.map((file) => (
          <div
            key={file.id}
            className="flex items-center gap-3 bg-gray-50 p-4 rounded-lg hover:bg-gray-100 transition-colors border border-gray-200"
          >
            <input
              type="checkbox"
              checked={selectedFiles.includes(file.name)}
              onChange={(e) => onSelect(file.name, e.target.checked)}
              className="rounded border-gray-300 text-[#024994] focus:ring-[#024994]"
            />
            <div className="flex items-center gap-3 flex-1">
              {canPreview(file.name) ? (
                <Eye className="w-5 h-5 text-[#024994]" />
              ) : (
                <FileText className="w-5 h-5 text-[#024994]" />
              )}
              <span className="text-gray-900">{file.name}</span>
            </div>
            {canPreview(file.name) && (
              <button
                onClick={() => onPreview(file.name)}
                className="text-[#024994] hover:text-[#024994]/80 transition-colors"
              >
                Previzualizare
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}